"use client";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { Disclosure, Popover, Transition } from "@headlessui/react";
import { useRive } from "@rive-app/react-canvas";
import clsx from "clsx";
import { useReducedMotion } from "framer-motion";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocale } from "../../utils/intl";
export function MainNavigation(_param) {
    var Link = _param.Link, data = _objectWithoutProperties(_param, [
        "Link"
    ]);
    var locale = useLocale();
    var mainMenuItems = locale === "de" ? data.nav_de : data.nav_en;
    var _ref = locale === "de" ? data.contact_de : data.contact_en, instagram = _ref.instagram, linkedin = _ref.linkedin, mastodon = _ref.mastodon;
    var _useState = _slicedToArray(useState(""), 2), currentPath = _useState[0], setCurrentPath = _useState[1];
    var rootButtonClasses = clsx("py-1 inline-flex group font-lexendGiga text-lg lg:text-2xl text-black hover:text-yellow transition-all focus focus-visible:outline-white");
    useEffect(function() {
        setCurrentPath(window.location.pathname);
    }, []);
    var RiveComponent = useRive({
        src: "/images/al_logo_white.riv",
        autoplay: useReducedMotion() ? false : true
    }).RiveComponent;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-between h-full"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "pt-14 md:pt-9 lg:pt-16"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: locale === "de" ? "/de" : "/",
        className: "block h-10 w-64 mx-auto"
    }, /*#__PURE__*/ React.createElement(RiveComponent, {
        "aria-label": "Amazee Labs",
        role: "img"
    }))), /*#__PURE__*/ React.createElement("ul", {
        className: clsx("tab:!hidden opacity-0 transition-opacity container-content-wrapper md:px-12 xl:px-0 mt-2 lg:mt-6", {
            "relative z-50 w-full opacity-100 md:pb-6": true
        })
    }, mainMenuItems ? mainMenuItems.map(function(param, index) {
        var label = param.label, link = param.link, children = param.children;
        /*#__PURE__*/ return React.createElement("li", {
            key: index + label + "header",
            className: "block w-full py-2.5 lg:py-3 first:pt-4 pr-4 xl:pr-6 2xl:pr-9 last:pr-0"
        }, !children ? /*#__PURE__*/ React.createElement(Link, {
            href: link,
            className: rootButtonClasses,
            activeClassName: "text-yellow"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "inline-flex flex-wrap items-center font-[450] justify-center text-center group-hover:text-yellow hover:duration-150 hover:delay-[0ms] delay-[0ms]"
        }, label)) : /*#__PURE__*/ React.createElement(Popover, null, function(param) {
            var open = param.open;
            /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Popover.Button, {
                className: clsx(rootButtonClasses, {
                    "text-yellow": open,
                    "border-yellow text-yellow": (children === null || children === void 0 ? void 0 : children.filter(function(child) {
                        return child.link === currentPath;
                    }).length) > 0 || currentPath === link
                })
            }, /*#__PURE__*/ React.createElement("span", {
                className: "inline-flex flex-wrap items-center justify-between text-center font-[450]"
            }, label), /*#__PURE__*/ React.createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "33",
                height: "12",
                viewBox: "0 0 33 12",
                fill: "none",
                className: "relative top-3 ml-4",
                stroke: "currentColor"
            }, /*#__PURE__*/ React.createElement("path", {
                d: "M0 6.6891H30.3357L25.9558 11.0256L26.94 12L33 6L26.94 0L25.9558 0.974389L30.3357 5.3109H0L0 6.6891Z",
                fill: "currentColor"
            }))), /*#__PURE__*/ React.createElement(Transition, {
                enter: "transition duration-100 ease-out",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "duration-75 ease-out",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0"
            }, /*#__PURE__*/ React.createElement(Popover.Panel, {
                className: "z-10 absolute top-4 right-0 lg:min-w-[50%]"
            }, /*#__PURE__*/ React.createElement(SlidingNavigationMenu, {
                items: children,
                fadeDuration: 300,
                scaleDuration: 300,
                parent: {
                    label: label,
                    link: link
                },
                Link: Link
            }))));
        }));
    }) : null), /*#__PURE__*/ React.createElement("div", {
        className: clsx("lg:hidden")
    }, /*#__PURE__*/ React.createElement(MobileNavigation, {
        mobileMenuItems: mainMenuItems,
        Link: Link
    }))), /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative z-50 w-full pb-10 md:pb-14 lg:pb-10 xl:pb-14 container-content-wrapper lg:max-w-full")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "px-8 md:px-12 xl:px-24 flex flex-col md:flex-row md:justify-between text-xs text-white font-normal"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "mailto:hello@amazeelabs.com",
        className: "focus focus-visible:outline-white"
    }, "hello@amazeelabs.com"), /*#__PURE__*/ React.createElement("div", {
        className: "flex mob:order-last mob:-ml-4 mob:mt-3"
    }, /*#__PURE__*/ React.createElement("a", {
        href: linkedin,
        target: "_blank",
        className: "block text-white pt-2 hover:underline focus focus-visible:outline-white px-4 group",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "LinkedIn"), /*#__PURE__*/ React.createElement("svg", {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 18 18",
        fill: "none",
        className: "group-hover:text-yellow transition duration-150 delay-[0ms] hover:duration-150 hover:delay-[0ms]"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0 1.99807C0 1.41891 0.202708 0.941108 0.608108 0.564672C1.01351 0.188218 1.54055 0 2.18919 0C2.82626 0 3.34169 0.185317 3.73552 0.555984C4.14092 0.938224 4.34363 1.43628 4.34363 2.05019C4.34363 2.60618 4.14672 3.06949 3.7529 3.44015C3.3475 3.82239 2.81467 4.01351 2.15444 4.01351H2.13707C1.49999 4.01351 0.984562 3.82239 0.590734 3.44015C0.196905 3.05791 0 2.57721 0 1.99807ZM0.225869 17.2008V5.59459H4.08301V17.2008H0.225869ZM6.22008 17.2008H10.0772V10.7201C10.0772 10.3147 10.1236 10.0019 10.2162 9.78185C10.3784 9.38802 10.6245 9.05501 10.9546 8.78282C11.2847 8.51061 11.6988 8.37452 12.1969 8.37452C13.4942 8.37452 14.1429 9.24903 14.1429 10.9981V17.2008H18V10.5463C18 8.83204 17.5946 7.53185 16.7838 6.64575C15.973 5.75965 14.9016 5.3166 13.5695 5.3166C12.0753 5.3166 10.9112 5.95946 10.0772 7.24517V7.27992H10.0598L10.0772 7.24517V5.59459H6.22008C6.24324 5.96524 6.25483 7.11775 6.25483 9.05212C6.25483 10.9865 6.24324 13.7027 6.22008 17.2008Z",
        fill: "currentColor"
    }))), /*#__PURE__*/ React.createElement("a", {
        href: instagram,
        target: "_blank",
        className: "block text-white pt-2 hover:underline focus focus-visible:outline-white px-4 group",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Instagram"), /*#__PURE__*/ React.createElement("svg", {
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 18 18",
        fill: "none",
        className: "group-hover:text-yellow transition duration-150 delay-[0ms] hover:duration-150 hover:delay-[0ms]"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M6.00073 9C6.00073 7.34321 7.34351 5.99976 9.00036 5.99976C10.6572 5.99976 12.0007 7.34321 12.0007 9C12.0007 10.6568 10.6572 12.0002 9.00036 12.0002C7.34351 12.0002 6.00073 10.6568 6.00073 9ZM4.37877 9C4.37877 11.5524 6.44784 13.6214 9.00036 13.6214C11.5529 13.6214 13.622 11.5524 13.622 9C13.622 6.44758 11.5529 4.37859 9.00036 4.37859C6.44784 4.37859 4.37877 6.44758 4.37877 9ZM12.7248 4.1954C12.7248 4.79152 13.2083 5.27569 13.8052 5.27569C14.4013 5.27569 14.8855 4.79152 14.8855 4.1954C14.8855 3.59927 14.402 3.11583 13.8052 3.11583C13.2083 3.11583 12.7248 3.59927 12.7248 4.1954ZM5.36387 16.3258C4.48637 16.2858 4.00945 16.1397 3.69248 16.0161C3.27226 15.8525 2.97274 15.6577 2.65722 15.3429C2.34242 15.0281 2.14686 14.7286 1.98401 14.3084C1.86041 13.9914 1.71429 13.5145 1.6743 12.6371C1.63068 11.6884 1.62196 11.4034 1.62196 9C1.62196 6.59661 1.63141 6.31236 1.6743 5.36292C1.71429 4.48546 1.86114 4.00929 1.98401 3.6916C2.14758 3.27141 2.34242 2.97189 2.65722 2.65638C2.97201 2.3416 3.27154 2.14604 3.69248 1.9832C4.00945 1.85961 4.48637 1.71349 5.36387 1.67351C6.31261 1.62989 6.5976 1.62116 9.00036 1.62116C11.4039 1.62116 11.6881 1.63061 12.6376 1.67351C13.5151 1.71349 13.9913 1.86034 14.309 1.9832C14.7292 2.14604 15.0287 2.3416 15.3442 2.65638C15.659 2.97116 15.8539 3.27141 16.0174 3.6916C16.141 4.00856 16.2872 4.48546 16.3272 5.36292C16.3708 6.31236 16.3795 6.59661 16.3795 9C16.3795 11.4027 16.3708 11.6876 16.3272 12.6371C16.2872 13.5145 16.1403 13.9914 16.0174 14.3084C15.8539 14.7286 15.659 15.0281 15.3442 15.3429C15.0294 15.6577 14.7292 15.8525 14.309 16.0161C13.992 16.1397 13.5151 16.2858 12.6376 16.3258C11.6888 16.3694 11.4039 16.3781 9.00036 16.3781C6.5976 16.3781 6.31261 16.3694 5.36387 16.3258ZM5.28971 0.0545234C4.33152 0.0981422 3.67721 0.250081 3.10505 0.472536C2.51327 0.702262 2.01163 1.0105 1.51072 1.51066C1.01054 2.01082 0.70229 2.51244 0.472555 3.10493C0.250091 3.67706 0.0981461 4.33134 0.0545256 5.2895C0.0101781 6.24911 0 6.5559 0 9C0 11.4441 0.0101781 11.7509 0.0545256 12.7105C0.0981461 13.6687 0.250091 14.3229 0.472555 14.8951C0.70229 15.4868 1.00981 15.9892 1.51072 16.4893C2.01091 16.9895 2.51254 17.297 3.10505 17.5275C3.67794 17.7499 4.33152 17.9019 5.28971 17.9455C6.25009 17.9891 6.55616 18 9.00036 18C11.4453 18 11.7514 17.9898 12.711 17.9455C13.6692 17.9019 14.3235 17.7499 14.8957 17.5275C15.4875 17.297 15.9891 16.9895 16.49 16.4893C16.9902 15.9892 17.2977 15.4868 17.5282 14.8951C17.7506 14.3229 17.9033 13.6687 17.9462 12.7105C17.9898 11.7502 18 11.4441 18 9C18 6.5559 17.9898 6.24911 17.9462 5.2895C17.9026 4.33134 17.7506 3.67706 17.5282 3.10493C17.2977 2.51317 16.9902 2.01155 16.49 1.51066C15.9898 1.0105 15.4875 0.702262 14.8964 0.472536C14.3235 0.250081 13.6692 0.0974152 12.7117 0.0545234C11.7521 0.0109047 11.4453 0 9.00109 0C6.55616 0 6.25009 0.0101777 5.28971 0.0545234Z",
        fill: "currentColor"
    }))), /*#__PURE__*/ React.createElement("a", {
        href: mastodon,
        target: "_blank",
        className: "block text-white pt-2 hover:underline focus focus-visible:outline-white px-4 group",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Mastodon"), /*#__PURE__*/ React.createElement("svg", {
        "aria-hidden": "true",
        className: "group-hover:text-yellow transition duration-150 delay-[0ms] hover:duration-150 hover:delay-[0ms]",
        width: "22",
        height: "24",
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0.00383672 7.88076C0.00383672 14.0778 -0.343163 21.7748 5.56284 23.3668C7.69484 23.9408 9.52684 24.0628 11.0008 23.9768C13.6748 23.8268 15.1758 23.0078 15.1758 23.0078L15.0858 21.0308C15.0858 21.0308 13.1748 21.6408 11.0268 21.5708C8.89984 21.4958 6.65684 21.3358 6.30984 18.6788C6.27784 18.4438 6.26284 18.1968 6.26284 17.9338C10.7698 19.0538 14.6118 18.4218 15.6708 18.2928C18.6248 17.9338 21.1988 16.0808 21.5258 14.3878C22.0408 11.7208 21.9998 7.87976 21.9998 7.87976C21.9998 2.67376 18.6468 1.14676 18.6468 1.14676C15.3558 -0.390242 6.61784 -0.374242 3.35884 1.14676C3.35684 1.14876 0.00383672 2.67476 0.00383672 7.88076ZM4.92684 5.21376C6.28984 3.66576 9.12784 3.56376 10.3918 5.54076L11.0028 6.58476L11.6138 5.54076C12.8828 3.55376 15.7258 3.67676 17.0788 5.21376C18.3268 6.67676 18.0478 8.05176 18.0478 14.5868H18.0458H15.5928V8.47076C15.5928 5.80876 12.2238 5.70676 12.2238 8.83976V12.1878H9.78684V8.83976C9.78684 5.70676 6.41784 5.80876 6.41784 8.47076V14.5878H3.95884C3.95884 8.04776 3.68484 6.66576 4.92684 5.21376Z",
        fill: "currentColor"
    })))), /*#__PURE__*/ React.createElement("span", {
        className: "block"
    }, "Call us +41 43 883 0614")))));
}
function MobileNavigation(param) {
    var mobileMenuItems = param.mobileMenuItems, Link = param.Link;
    return /*#__PURE__*/ React.createElement(MobileSlidingNavigationMenu, {
        scaleDuration: 0,
        fadeDuration: 150,
        className: "mt-5",
        items: mobileMenuItems,
        Link: Link
    });
}
function MobileSlidingNavigationMenu(_param) {
    var items = _param.items, parent = _param.parent, className = _param.className, Link = _param.Link, rest = _objectWithoutProperties(_param, [
        "items",
        "parent",
        "className",
        "Link"
    ]);
    var menuItemClasses = "lg:px-8";
    var _useState = _slicedToArray(useState(""), 2), currentPath = _useState[0], setCurrentPath = _useState[1];
    useEffect(function() {
        setCurrentPath(window.location.pathname);
    }, []);
    return /*#__PURE__*/ React.createElement(MenuTreeWrapper, null, /*#__PURE__*/ React.createElement("ul", {
        className: clsx("mobile-nav relative z-10 text-[1.3rem] md:text-2xl font-lexendGiga font-normal lg:pb-20 pl-8 md:pl-24", className)
    }, parent ? /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Disclosure.Button, {
        className: clsx("focus group w-full max-w-full items-center py-3 text-left", menuItemClasses)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "inline-flex items-center"
    }, /*#__PURE__*/ React.createElement("svg", {
        className: "mr-3 md:mr-4 mt-1.5 w-[29px] h-[10px] md:w-[34px] md:h-[12px]",
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "8",
        viewBox: "0 0 22 8",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22 3.5406L1.77619 3.5406L4.69613 0.649593L4.04003 0L0 4L4.04003 8L4.69613 7.35041L1.77619 4.4594L22 4.4594V3.5406Z",
        fill: "#FDE900"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "inline-flex pt-1 text-yellow duration-300"
    }, parent.label))))) : null, items && items.map(function(currentItem, index) {
        /*#__PURE__*/ return React.createElement("li", {
            key: index
        }, currentItem.children ? /*#__PURE__*/ React.createElement(Disclosure, null, function(param) {
            var open = param.open;
            var _currentItem_children;
            /*#__PURE__*/ return React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Disclosure.Button, {
                className: clsx("focus group w-full text-left py-2.5 md:py-4", {
                    "text-yellow": ((_currentItem_children = currentItem.children) === null || _currentItem_children === void 0 ? void 0 : _currentItem_children.map(function(param) {
                        var link = param.link;
                        return link === currentPath;
                    })) || currentPath === currentItem.link
                }, menuItemClasses)
            }, /*#__PURE__*/ React.createElement("div", {
                className: "inline-flex items-center text-black hover:text-yellow transition-all"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "flex w-full max-w-full items-center justify-between pt-1"
            }, currentItem.label), /*#__PURE__*/ React.createElement("svg", {
                className: "ml-1.5 mt-1.5 w-[29px] h-[10px] md:w-[40px] md:h-[15px]",
                xmlns: "http://www.w3.org/2000/svg",
                width: "29",
                height: "10",
                viewBox: "0 0 22 8",
                fill: "none"
            }, /*#__PURE__*/ React.createElement("path", {
                d: "M0 4.4594H20.2238L17.3039 7.35041L17.96 8L22 4L17.96 0L17.3039 0.649593L20.2238 3.5406H0L0 4.4594Z",
                fill: "currentColor"
            }))))), /*#__PURE__*/ React.createElement(SubmenuTransition, _extends({
                show: open
            }, rest), /*#__PURE__*/ React.createElement(Disclosure.Panel, null, /*#__PURE__*/ React.createElement(MobileSlidingNavigationMenu, _extends({}, rest, {
                items: currentItem.children || [],
                parent: currentItem,
                grandParent: parent,
                Link: Link,
                className: "not-first-level pl-0"
            })))));
        }) : /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Link, {
            href: currentItem.link,
            className: clsx("focus group block w-full max-w-full py-2.5 md:py-4 not-first-level-link", menuItemClasses),
            activeClassName: "text-yellow"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "inline-flex pt-1 text-black hover:text-yellow transition-all"
        }, currentItem.label))));
    })));
}
function MenuItemTransition(param) {
    var children = param.children;
    var expanded = useContext(MenuTreeContext).expanded;
    return /*#__PURE__*/ React.createElement(Transition, {
        show: !expanded
    }, children);
}
var MenuTreeContext = /*#__PURE__*/ createContext({
    expanded: true,
    setExpanded: function() {
        return undefined;
    }
});
function MenuTreeWrapper(param) {
    var children = param.children;
    var _useState = _slicedToArray(useState(false), 2), expanded = _useState[0], setExpanded = _useState[1];
    return /*#__PURE__*/ React.createElement(MenuTreeContext.Provider, {
        value: {
            expanded: expanded,
            setExpanded: setExpanded
        }
    }, children);
}
function SlidingNavigationMenu(_param) {
    var items = _param.items, parent = _param.parent, grandParent = _param.grandParent, className = _param.className, Link = _param.Link, rest = _objectWithoutProperties(_param, [
        "items",
        "parent",
        "grandParent",
        "className",
        "Link"
    ]);
    var menuItemClasses = "py-2";
    return /*#__PURE__*/ React.createElement(MenuTreeWrapper, null, /*#__PURE__*/ React.createElement("ul", {
        className: clsx("font-lexendGiga text-black desktop-nav", className)
    }, items.map(function(currentItem, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: index
        }, currentItem.children ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement("span", {
            className: "inline-flex items-start justify-between font-normal"
        }, currentItem.label)), /*#__PURE__*/ React.createElement(SlidingNavigationMenu, _extends({}, rest, {
            items: currentItem.children || [],
            parent: currentItem,
            grandParent: parent,
            Link: Link
        }))) : /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Link, {
            href: currentItem.link,
            className: clsx("focus focus-visible:outline-white focus-visible:-outline-offset-[1px] group block w-full max-w-full py-2 hover:text-yellow delay-[0ms] hover:delay-[0ms]", menuItemClasses),
            activeClassName: "text-yellow"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "inline-flex items-center justify-between font-normal"
        }, currentItem.label))));
    })), /*#__PURE__*/ React.createElement("ul", {
        className: clsx("mobile-nav lg:hidden", className)
    }, grandParent ? /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Disclosure.Panel, null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Disclosure.Button, {
        className: clsx("focus group w-full max-w-full py-3 text-left", menuItemClasses)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-flex items-center pt-1"
    }, grandParent ? grandParent.label : "Main navigation"))))) : null, parent ? /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Link, {
        href: parent.link,
        className: clsx("focus group block w-full max-w-full py-3 last:border-0", menuItemClasses),
        activeClassName: "text-yellow"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-flex pt-1 duration-300"
    }, parent.label)))) : null, items.map(function(currentItem, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: index
        }, currentItem.children ? /*#__PURE__*/ React.createElement(Disclosure, null, function(param) {
            var open = param.open;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Disclosure.Button, {
                className: clsx("focus group w-full py-3 text-left", menuItemClasses)
            }, /*#__PURE__*/ React.createElement("span", {
                className: "flex w-full max-w-full items-center justify-between pt-1 hover:text-yellow"
            }, currentItem.label))), /*#__PURE__*/ React.createElement(SubmenuTransition, _extends({
                show: open
            }, rest), /*#__PURE__*/ React.createElement(Disclosure.Panel, null, /*#__PURE__*/ React.createElement(SlidingNavigationMenu, _extends({}, rest, {
                Link: Link,
                items: currentItem.children || [],
                parent: currentItem,
                grandParent: parent
            })))));
        }) : /*#__PURE__*/ React.createElement(MenuItemTransition, _extends({}, rest), /*#__PURE__*/ React.createElement(Link, {
            href: currentItem.link,
            className: clsx("focus group block w-full max-w-full py-3", menuItemClasses),
            activeClassName: "text-yellow"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "inline-flex pt-1 duration-300"
        }, currentItem.label))));
    })));
}
function SubmenuTransition(param) {
    var children = param.children, show = param.show;
    var setExpanded = useContext(MenuTreeContext).setExpanded;
    return /*#__PURE__*/ React.createElement(Transition, {
        show: show,
        beforeEnter: function() {
            setExpanded(true);
        },
        beforeLeave: function() {
            setExpanded(false);
        }
    }, children);
}
